// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"113c2fb8","752":"e4d88cb4"}[chunkId] + ".chunk.css";
};